import React, { useEffect, useState } from "react";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import AddIcon from "@mui/icons-material/Add";
import VisibilityIcon from "@mui/icons-material/Visibility";
import ChatIcon from "@mui/icons-material/Chat";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import CreateNewChatbot from "./AiModels/CreateNewChatbot";

const AiChatbot = () => {
  const [openCreateNewChatbot, setOpenCreateNewChatbot] = useState(false);

  useEffect(() => {
    console.log(openCreateNewChatbot);
  }, [openCreateNewChatbot]);
  return (
    <div className="px-4 py-6">
      <CreateNewChatbot
        isOpen={openCreateNewChatbot}
        setIsOpen={setOpenCreateNewChatbot} // Pass state and handler as props
      />
      <div className="p-[14px] shadow-cs rounded-lg mb-[20px] bg-white">
        <h1 className="text-[16px] md:text-[18px] cursor-pointer font-medium text-gray-900 mb-2">
          Embed Ai Chatbot
        </h1>
        <div className="flex items-center text-sm text-gray-500">
          <a href="/" className="hover:text-gray-700">
            Home
          </a>
          <span className="mx-2">
            <ChevronRightIcon className="w-4 h-4" />
          </span>
          <span className="text-gray-700">Ai Chatbot</span>
        </div>
      </div>
      <div className=" flex items-center justify-between flex-wrap gap-[14px] md:gap-[0] mb-[20px]">
        <div className="flex items-center gap-[16px]">
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium   rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#8125b0]">
            geminiAi: 99157
          </button>
          <button className="pt-[8px] pb-[8px] pl-[16px] pr-[16px] font-medium  rounded-2xl shadow-cs bg-white text-[13px] md:text-[14px] text-[#008000]">
            OpenAi: 76904
          </button>
        </div>
        <button
          onClick={() => setOpenCreateNewChatbot(true)}
          className=" justify-center create-model md:flex items-center second-btn"
        >
          <AddIcon className="icons-crm" />
          Create New
        </button>
      </div>

      <div className="space-y-4">
        {[1].map((item) => (
          <div
            key={item}
            className="flex items-center justify-between p-4 bg-white rounded-lg shadow-cs"
          >
            <div className="flex items-center gap-2">
              <div>
                <ChatIcon className="text-[#27004a]" />
              </div>
              <div>
                <p className="  text-[13px] md:font-medium md:text-[14px] ">
                  ID: HKP75
                </p>
              </div>
            </div>
            <div className="flex items-center gap-2">
              <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
                <VisibilityIcon />
              </button>
              <button className="p-2 text-gray-600 hover:text-gray-800 transition-colors">
                <DeleteOutlineIcon />
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default AiChatbot;
